<template>
  <main class="flex-1 flex flex-col bg-[#fafbfc] relative overflow-hidden">
    <div class="shrink-0 p-6 lg:p-8 border-b border-[#1c4848]/5">
      <div class="max-w-[1600px] mx-auto flex justify-between items-center">
        <div class="h-8 w-48 rounded-lg bg-[#1c4848]/10 animate-pulse" />
        <div class="h-10 w-64 rounded-xl bg-[#1c4848]/10 animate-pulse" />
      </div>
    </div>
    <div class="flex-1 overflow-y-auto p-6 lg:p-8 space-y-6">
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-6 max-w-[1600px] mx-auto">
        <div class="lg:col-span-7 h-64 rounded-2xl bg-[#1c4848]/10 animate-pulse" />
        <div class="lg:col-span-5 grid grid-cols-2 gap-4">
          <div class="h-24 rounded-xl bg-[#1c4848]/10 animate-pulse" />
          <div class="h-24 rounded-xl bg-[#1c4848]/10 animate-pulse" />
          <div class="h-24 rounded-xl bg-[#1c4848]/10 animate-pulse" />
          <div class="h-24 rounded-xl bg-[#1c4848]/10 animate-pulse" />
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-[1600px] mx-auto">
        <div v-for="i in 4" :key="i" class="h-32 rounded-2xl bg-[#1c4848]/10 animate-pulse" />
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-[1600px] mx-auto">
        <div class="lg:col-span-2 h-72 rounded-2xl bg-[#1c4848]/10 animate-pulse" />
        <div class="space-y-6">
          <div class="h-40 rounded-2xl bg-[#1c4848]/10 animate-pulse" />
          <div class="h-48 rounded-2xl bg-[#1c4848]/10 animate-pulse" />
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
</script>
